import { isString } from 'fitify-types/src/type-guards/common'
import { useGrowthBook } from 'fitify-ui-onboarding/src/utils/growthbook/generated'
import { useEffect, useMemo } from 'react'

import { useFunnel } from 'hooks/useFunnel'
import { useDataState } from 'utils/state'

export const usePrintableId = () => {
  const { set } = useDataState()
  const funnel = useFunnel()
  const growthBook = useGrowthBook()

  const printableId = useMemo(() => {
    const value = funnel
      ? growthBook.evalFeature(`${funnel}_printable`)?.value
      : undefined
    return isString(value) ? value : undefined
  }, [funnel, growthBook])

  useEffect(() => {
    set('common', { printableId, subscriptionFunnel: funnel })
  }, [funnel, printableId, set])

  return printableId
}
